module.exports = __webpack_public_path__ + "img/Orange.c8be6d3f.png";